/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedMedicalActionListSchema } from '../models/PagedMedicalActionListSchema';
import type { PagedMedicalActionSchema } from '../models/PagedMedicalActionSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MedicalActionsApi {
    /**
     * Get Medical Action List
     * Get medical action list. <br>Required permission: get_medical_action_list
     * @returns PagedMedicalActionListSchema OK
     * @throws ApiError
     */
    public static insuranceGetMedicalActionListGet({
        expertiseId,
        search,
        limit = 100,
        offset,
    }: {
        expertiseId?: (string | null),
        search?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedMedicalActionListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/medical-actions/medical_action/',
            query: {
                'expertise_id': expertiseId,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Filtered Medical Action List
     * Get filtered medical action list. <br>Required permission: get_filtered_medical_action_list
     * @returns PagedMedicalActionSchema OK
     * @throws ApiError
     */
    public static insuranceGetFilteredMedicalActionListGet({
        userId,
        dateFrom,
        dateTo,
        insuranceCode,
        companyInsuranceWorkspaceId,
        limit = 100,
        offset,
    }: {
        userId?: (string | null),
        dateFrom?: (string | null),
        dateTo?: (string | null),
        insuranceCode?: (string | null),
        companyInsuranceWorkspaceId?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedMedicalActionSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/medical-actions/medical_action_list',
            query: {
                'user_id': userId,
                'date_from': dateFrom,
                'date_to': dateTo,
                'insurance_code': insuranceCode,
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Generate Medical Action Export
     * Export filtered medical action list to Excel. <br>Required permission: export_medical_action_list
     * @returns any Accepted
     * @throws ApiError
     */
    public static insuranceGenerateMedicalActionExportPost({
        userId,
        dateFrom,
        dateTo,
        insuranceCode,
        companyInsuranceWorkspaceId,
    }: {
        userId?: (string | null),
        dateFrom?: (string | null),
        dateTo?: (string | null),
        insuranceCode?: (string | null),
        companyInsuranceWorkspaceId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/medical-actions/export',
            query: {
                'user_id': userId,
                'date_from': dateFrom,
                'date_to': dateTo,
                'insurance_code': insuranceCode,
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
            },
        });
    }
}
